import type { Role } from "@datamole/lssa-permissions";

import type { View } from "@/features/views/view-definitions";

export const roleToViewMap: Record<Role, View[]> = {
    fmsAdvisor: ["fmsAdvisor"],
    tssTechnician: ["technician"],
    tssTeamLead: ["teamLead", "technician"],
    serviceManager: ["serviceManager"],
};
